import { render, staticRenderFns } from "./list_products_component.vue?vue&type=template&id=46714a0c&scoped=true"
import script from "./list_products_component.vue?vue&type=script&lang=js"
export * from "./list_products_component.vue?vue&type=script&lang=js"
import style0 from "./list_products_component.vue?vue&type=style&index=0&id=46714a0c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46714a0c",
  null
  
)

export default component.exports